import { render, staticRenderFns } from "./ResourceContributorCard.vue?vue&type=template&id=d5f93326&scoped=true"
import script from "./ResourceContributorCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourceContributorCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ResourceContributorCard.vue?vue&type=style&index=0&id=d5f93326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f93326",
  null
  
)

export default component.exports